import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
const getters = {};
const actions = {};
const mutations = {
  curLongitude(state, lon) {
    state.curLongitude = lon;
    // state.url = url;
  },
  curLatitude(state, lat) {
    state.curLatitude = lat;
    // state.url = url;
  },
  curCity(state, city) {
    state.curCity = city;
    // state.url = url;
  },
  curStoreId(state, storeid) {
    state.curStoreId = storeid;
    // state.url = url;
  },
  curLocationAddr(state, addr) {
    state.curLocationAddr = addr;
    // state.url = url;
  },
  locateLongitude(state, lon) {
    state.locateLongitude = lon;
    // state.url = url;
  },
  locateLatitude(state, lat) {
    state.locateLatitude = lat;
    // state.url = url;
  },
  locateCity(state, city) {
    state.locateCity = city;
    // state.url = url;
  },
  postal_code(state, code) {
    state.postal_code = code;
    // state.url = url;
  },
  cartNum(state, num) {
    state.cartNum = num;
    // state.url = url;
  },
  amount(state, amount) {
    state.amount = amount;
  },
  curAddrId(state, curAddrId) {
    state.curAddrId = curAddrId;
  },
  changeisLoading(state, data) {
    state.isLoading = data
  },
  curAreaLogo(state,data) {
    state.curAreaLogo = data
  },
  curAreaVal(state,data) {
    state.curAreaVal = data
  },
  resetState(state) {
    // Merge rather than replace so we don't lose observers
    // https://github.com/vuejs/vuex/issues/1118
    let emptystate = { //要设置的全局访问的state对象
      curLongitude: "", //经纬度（定位、地址）
      curLatitude: "", //经纬度（定位、地址）
      curCity: "", //城市（定位、地址）
      curStoreId: "", //门店（定位、地址）
      curLocationAddr: "", //地址详细（定位、地址）
      locateLongitude: "", //定位经纬度
      locateLatitude: "", //定位经纬度
      locateCity: "", //当前定位城市
      locateAddr: "", //当前定位位置
      locatePostalcode: "", //当前定位邮编
      postal_code: "", //当前选择地址邮编
      cartNum: "", //购物车数量
      curAddrId: "", //地址id
      amount: "", //购物车金额
      curAreaLogo:"",  // 当前城市的logo
      curAreaVal:"",   // 当前城市的编码
    }
    Object.assign(state, emptystate)
  }
};
const state = { //要设置的全局访问的state对象
  curLongitude: "", //经纬度（定位、地址）
  curLatitude: "", //经纬度（定位、地址）
  curCity: "", //城市（定位、地址）
  curStoreId: "", //门店（定位、地址）
  curLocationAddr: "", //地址详细（定位、地址）
  locateLongitude: "", //定位经纬度
  locateLatitude: "", //定位经纬度
  locateCity: "", //当前定位城市
  locateAddr: "", //当前定位位置
  locatePostalcode: "", //当前定位邮编
  postal_code: "", //当前选择地址邮编
  cartNum: "", //购物车数量
  curAddrId: "", //地址id
  amount: "", //购物车金额
  curAreaLogo:"",  // 当前城市的logo
  curAreaVal:"",   // 当前城市的编码
  isLoading: false //加載狀態

};

const store = new Vuex.Store({
  mutations,
  state
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js